import { render, staticRenderFns } from "./c-sidebar.vue?vue&type=template&id=1f1827c2&"
import script from "./c-sidebar.vue?vue&type=script&lang=js&"
export * from "./c-sidebar.vue?vue&type=script&lang=js&"
import style0 from "./c-sidebar.vue?vue&type=style&index=0&id=1f1827c2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports